<template>

	<div>

		<section class="outer-pad">

			<Table 
				:headings="tableHeadings" 
				:items="accountsGood" 
				emptyLabel="There are no google accounts added at the moment" 
				:loading="loading"
				loadingText="Fetching accounts..."
				@delete="deleteAccount"
				@deleteProject="deleteProject"
			/>

			<h3 class="accounts-reconnecting" v-if="accountsBad.length>0">Accounts That Need Reconnecting</h3>

			<Table  
				:headings="tableHeadings" 
				:items="accountsBad" 
				@delete="deleteAccount"
				@reconnectAccount="reconnectAccount"
				@deleteProject="deleteProject"
				v-if="accountsBad.length>0"
			/>

		</section>

		<div class="modal" v-if="showGoogleConnect">

			<div class="modal-wrap">

				<div class="modal-inner">

					<h2 class="modal-title">&nbsp;<span class="close" @click="closeGoogleConnect()">X</span></h2>

					<div class="modal-inner-scroll">

						<GoogleConnect 
							scope="https://www.googleapis.com/auth/webmasters.readonly https://www.googleapis.com/auth/analytics.readonly https://www.googleapis.com/auth/userinfo.email"
							clientId="444580885070-gc0jr5mklt4keng77gum1saqme2isr9c.apps.googleusercontent.com"
							:confirmUnder="true"
							:showLoading="true"
							:reconnectId="reconnectId"
							@complete="googleConnectComplete"
						/>

					</div>

				</div>

			</div>

		</div>

	</div>

</template>

<script>

import { mapMutations } from 'vuex'
import ApiService from './../../services/api.service'
import general from './../../utils/general'
import Table from './../../components/Table.vue'
import TableButton from './../../components/Display/TableButton.vue'
import TableImage from './../../components/Display/TableImage.vue'
import MultiLinkWithIcon from './../../components/Display/MultiLinkWithIcon.vue'
import GoogleConnect from './../../components/GoogleConnect.vue'
export default {
	name: 'GoogleAccounts',
	components: {
		Table, TableButton, TableImage, GoogleConnect
	},
	data() {
		return {
			accounts: [],
			loading: true,
			showGoogleConnect: false,
			reconnectId: '',
			tableHeadings: {
				image: { value: '', component: TableImage },
				email: { value: 'Account' },
				projects: { value: 'Domains', emptyCell: "None assigned", component: MultiLinkWithIcon },
				delete: { value: '', component: TableButton, event: 'delete' },
				reconnect: { value: '', component: TableButton, event: 'reconnectAccount', emptyCell: "&nbsp;" }
			}
		}
	},
	computed: {

		accountsGood () {

			let accounts = [];

			this.accounts.forEach ( function (account) {

				if ( typeof account.invalidGrant === 'undefined' || account.invalidGrant === false ) {

					accounts.push(account);

				}

			});

			return accounts;

		},

		accountsBad () {

			let accounts = [];

			this.accounts.forEach ( function (account) {

				if ( typeof account.invalidGrant !== 'undefined' && account.invalidGrant === true ) {

					accounts.push(account);

				}

			});

			return accounts;

		}

	},
	methods: {

		...mapMutations('general',['updateLoadingText']),

		deleteProject (info) {

			let m = 'Are you sure you want to remove ' + info.name + ' from this account?';

			m += '<br />This will remove any URLs/Keywords that have been pulled from that account that domain. (If you\'re unsure about this, please contact support)';

			this.$dialog
				.confirm( m, { okText: 'Yes please', cancelText: 'Cancel',})
				.then(function() {

					this.updateLoadingText( true );

					ApiService.delete( 'google/accounts/' + info.googleAccount + '/project/' + info._id )
					.then( function( info ) {

						this.updateLoadingText();
						this.accounts = info.data;

					}.bind(this))
					.catch( function(err) {

						this.updateLoadingText();

					}.bind(this));

				}.bind(this))
				.catch(function() {
					

				});

		},

		closeGoogleConnect () {

			this.showGoogleConnect = false;

			general.modalClose();

		},

		googleConnectComplete(info) {

			if ( info.msg ) this.$snotify[info.status]( info.msg, 'Google' );

			if ( info.status === 'success' ) {

				this.loadAccounts ();

			}

		},

		reconnectAccount (info) {

			this.reconnectId = info.googleId;
			this.showGoogleConnect = true;

		},

		deleteAccount(info) {

			let m = 'Are you sure you want to delete ' + info.name + '?';

			m += '<br />This will remove any URLs/Keywords that have been pulled from that account into all projects! (If you\'re unsure about this, please contact support)';

			this.$dialog
				.confirm( m, { okText: 'Yes please', cancelText: 'Cancel',})
				.then(function() {

					this.updateLoadingText( "Deleting account, one moment.." );

					ApiService.delete( 'google/accounts/' + info._id )
					.then( function( info ) {

						this.updateLoadingText();
						this.accounts = info.data;

					}.bind(this))
					.catch( function(err) {

						this.updateLoadingText();

					}.bind(this));

				}.bind(this))
				.catch(function() {
					

				});

		},

		loadAccounts () {

			ApiService.get( "google/accounts" )
			.then( function( info ) {

				this.accounts = info.data;
				this.loading = false;

			}.bind(this))
			.catch( function(err) {}.bind(this));


		}
		
	},
	created() {

		this.loadAccounts ();

	}
}
</script>

<style lang="less" scoped>
.accounts-reconnecting {
	margin: 30px 0 8px;
}
.modal .modal-inner {
	max-width: 500px;
}
</style>
